module.exports = __webpack_public_path__ + "media/Video 131.10fb7354.mp4";